import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import { useRouting } from 'hooks/useRouting';

export const AboutDepositDataModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  const routing = useRouting();
  const goSecurityaccounts = (): void => {
    routing.pushRouting({ path: '/securityaccounts' }, true);
  };
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-sm text-bluegray-700">
          <div className="flex flex-row">
            <div className="flex-grow text-lg font-bold text-gray-800">
              表示されない理由について
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4">
            以下に該当する場合はデータが表示されません。
          </div>
          <div className="mt-6 leading-6">
            （1）「入金」情報の未対応の証券会社の情報対応済み証券会社は以下のとおりです。
            <br />
            【対応済み】
            <br />
            ・SBI証券、楽天証券
            <br />
            【未対応】
            <br />
            ・上記以外の証券会社
            <br />
            ・確定拠出年金口座
            <br />
            ・マネーツリーで連携した口座
          </div>
          <div className="mt-6 leading-6">
            （2）配当金・分配金・利金の受け取りを証券口座以外に設定している場合
          </div>
          <div className="mt-6 leading-6">
            （3）口座連携に失敗している場合
            連携口座一覧画面から口座の状況を確認してください。
          </div>
          <div
            className="cursor-pointer text-blue-700"
            onClick={() => goSecurityaccounts()}>
            連携口座一覧を確認
          </div>
          <div className="mt-6 text-sm">
            上記に該当しない場合はお問い合わせをお願いします。
          </div>
          <div className="text-blue-700">
            <a
              href={`https://support.minkabu.jp/hc/ja/requests/new`}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer">
              お問い合わせ
            </a>
          </div>
          <button
            className="mt-4 p-2 justify-center w-full text-bluegray-500"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
